import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Group = styled.g(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (props) { return props.color; });
var templateObject_1;
